import { SubscriptionName } from '@anm/api/modules/subscription';
import { isAnon } from '@anm/auth/helpers/authAnon';
import isFreeSubscription from '@anm/helpers/subscription/isFreeSubscription';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import getUrlByRouterName from '../../../../helpers/router/getUrlByRouterName';
import routes from '../../../../routes';
import { userSelectors } from '../../../../store/modules/user';

const { Router } = routes;

const goSignUp = (selectedSubscriptionName: SubscriptionName) => {
  const isFree = isFreeSubscription(selectedSubscriptionName);

  const myVideosUrl = getUrlByRouterName('my-projects');
  const pricingUrl = getUrlByRouterName('pricing');

  const pricingRedirectUrl = `${pricingUrl}?plan=${selectedSubscriptionName}`;
  const redirectUrl = isFree && myVideosUrl ? myVideosUrl : pricingUrl ? pricingRedirectUrl : '';

  Router.pushRoute('signup', {
    redirectUrl
  });
};

const useGetPlanHandler = (onModalOpen: (subscriptionName: SubscriptionName) => void) => {
  const profile = useSelector(userSelectors.selectUserProfile);

  const handleGetPlan = useCallback(
    (selectedSubscriptionName: SubscriptionName) => {
      if (profile && !isAnon()) {
        onModalOpen(selectedSubscriptionName);
        return;
      }
      goSignUp(selectedSubscriptionName);
    },
    [profile]
  );

  return handleGetPlan;
};

export default useGetPlanHandler;
